var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.refId,staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.refId}},[_vm._v(" "+_vm._s(_vm.optionShow))])
}
var staticRenderFns = []

export { render, staticRenderFns }